import { Helmet } from "react-helmet-async";

export const DenySearchEngineIndex = () => {
  return (
    <Helmet prioritizeSeoTags>
      <meta name="robots" content="noindex,nofollow,noarchive" />
    </Helmet>
  );
};
